import { type ManagedBy } from "@/shared/domain/triggers";

/** What each Roboto-installed trigger is for, by its feature key. */
const SYSTEM_FEATURE_EXPLANATIONS: Record<string, string> = {
  session_metrics:
    "Roboto installed this trigger to compute session metrics. Each time a session is fully ingested, it runs Roboto's session_metrics action on that session.",
};

const GENERIC_EXPLANATION =
  "Roboto installed this trigger to run a platform feature.";

/** Why Roboto installed a trigger, and what members may do with it. */
export function systemManagedExplanation(
  managedBy: ManagedBy | null | undefined,
): string {
  const feature =
    (managedBy?.id !== undefined
      ? SYSTEM_FEATURE_EXPLANATIONS[managedBy.id]
      : undefined) ?? GENERIC_EXPLANATION;
  return `${feature} You can turn it on or off, but not edit or delete it.`;
}
